/**
 * 根据视口计算表格贴底高度（表体 scroll.y + 外容器固定高度）
 */
export function calcStickyTableLayout(hostEl, options = {}) {
  const theadH = options.theadH || 55;
  const paginationH = options.paginationH || 56;
  const bottomGap = options.bottomGap || 24;
  const minScrollY = options.minScrollY || 240;
  const minHostH = options.minHostH || 280;

  if (!hostEl || typeof window === "undefined") {
    return { scrollY: minScrollY, hostHeight: minHostH };
  }

  const rect = hostEl.getBoundingClientRect();
  const hostHeight = Math.max(minHostH, window.innerHeight - rect.top - bottomGap);
  const scrollY = Math.max(minScrollY, hostHeight - paginationH - theadH);
  return { scrollY, hostHeight };
}
